import React, { CSSProperties } from 'react';
import DetailSectionHeader from '../UIComponents/DetailSectionHeader';
import Appliances from '../DataGroupComponents/Appliances';
import AssessmentAndTaxes from '../DataGroupComponents/AssessmentAndTaxes';
import Basement from '../DataGroupComponents/Basement';
import Bathrooms from '../DataGroupComponents/Bathrooms';
import Building from '../DataGroupComponents/Building';
import Cooling from '../DataGroupComponents/Cooling';
import ExteriorFeatures from '../DataGroupComponents/ExteriorFeatures';
import Fireplace from '../DataGroupComponents/Fireplace';
import Heating from '../DataGroupComponents/Heating';
import InteriorFeatures from '../DataGroupComponents/InteriorFeatures';
import LotInfo from '../DataGroupComponents/LotInfo';
import Neighborhood from '../DataGroupComponents/Neighborhood';
import Ownership from '../DataGroupComponents/Ownership';
import Parking from '../DataGroupComponents/Parking';
import Rooms from '../DataGroupComponents/Rooms';
import SewerWater from '../DataGroupComponents/SewerWater';
import SchoolDistricts from '../DataGroupComponents/SchoolDistricts';
import { mapOriginatingSystemToSource } from '../../../utilities/util';

interface FullDetailsProps {
	detailListStyle: CSSProperties,
	status: string | undefined,
	time: number | undefined,
	propertyType: string | undefined,
	lotSizeAcres: number | undefined,
	livingArea: number | undefined,
	yearBuilt: Date | undefined,
	community: string | undefined,
	associationYN: boolean | undefined,
	associationFee: number | undefined,
	bathroomsFull: number | undefined,
	bathroomsHalf: number | undefined,
	roomsTotal: number | undefined,
	bedroomsTotal: number | undefined,
	fireplacesTotal: number | undefined,
	fireplaceFeatures: Array<string> | undefined,
	heating: Array<string> | undefined,
	fireplaceYN: boolean | undefined,
	cooling: Array<string> | undefined,
	basement: Array<string> | undefined,
	appliances: Array<string> | undefined,
	interiorFeatures: Array<string> | undefined,
	parkingFeatures: Array<string> | undefined,
	garageYN: boolean | undefined,
  attachedGarageYN: boolean | undefined,
  carportYN: boolean | undefined,
  carportSpaces: number | undefined,
  archStyle: Array<string> | undefined,
  accessibilityFeatures: Array<string> | undefined,
  stories: number | undefined,
  storiesTotal: number | undefined,
  flooring: Array<string> | undefined,
  roof: Array<string> | undefined,
  constructionMaterials: Array<string> | undefined,
  exteriorFeatures: Array<string> | undefined,
  fencing: Array<string> | undefined,
  poolPrivateYN: boolean | undefined,
  poolFeatures: Array<string> | undefined,
  lotSizeArea: number | undefined,
  parcelNumber: number | undefined,
  ownership: string | undefined,
  ownershipType: string | undefined,
  elementary: string | undefined,
  middle: string | undefined,
  high: string | undefined,
  sewer: Array<string> | undefined,
  water: Array<string> | undefined,
  subdivisionName: string | undefined,
  zoningDescription: string | undefined,
  taxAssessedValue: number | undefined,
  annualTax: number | undefined,
  taxYear: Date | undefined,
  mlsCode: string | undefined,
}

const FullDetails = ({detailListStyle, propertyType, lotSizeAcres, yearBuilt, community, associationYN, associationFee, bathroomsFull, bathroomsHalf, roomsTotal, bedroomsTotal, fireplacesTotal, fireplaceFeatures, heating, fireplaceYN, cooling, basement, appliances, interiorFeatures, parkingFeatures, garageYN, attachedGarageYN, carportYN, carportSpaces, archStyle, accessibilityFeatures, stories, storiesTotal, flooring, roof, constructionMaterials, exteriorFeatures, fencing, poolPrivateYN, poolFeatures, lotSizeArea, livingArea, parcelNumber, ownership, ownershipType, elementary, middle, high, sewer, water, subdivisionName, zoningDescription, taxAssessedValue, annualTax, taxYear, mlsCode} : FullDetailsProps) => {
	return (
		<div id="propertyDetailsFull">
			{/* INTERIOR DETAILS */}
      {propertyType?.trim().toLowerCase()!=="land" &&
        <article className="property-details__section">
          <DetailSectionHeader icon="fa-bed" title="Interior Details" />
          <div className="property-details__section-info d-flex align-items-start">
            <div className="col-6">
              <Bathrooms
                detailListStyle={detailListStyle}
                bathroomsFull={bathroomsFull}
                bathroomsHalf={bathroomsHalf}
              />
              <Basement
                detailListStyle={detailListStyle}
                basement={basement}
              />
              <Fireplace
                detailListStyle={detailListStyle}
                fireplacesTotal={fireplacesTotal}
                fireplaceFeatures={fireplaceFeatures}
              />
              <Heating
                detailListStyle={detailListStyle}
                heating={heating}
                fireplaceYN={fireplaceYN}
              />
              <Cooling
                detailListStyle={detailListStyle}
                cooling={cooling}
              />
            </div>

            <div className="col-6">
              <Rooms
                detailListStyle={detailListStyle}
                roomsTotal={roomsTotal}
                bedroomsTotal={bedroomsTotal}
              />
              <Appliances
                detailListStyle={detailListStyle}
                appliances={appliances}
              />
              <InteriorFeatures
                detailListStyle={detailListStyle}
                interiorFeatures={interiorFeatures}
              />
            </div>
          </div>
        </article>
      }
			{/* PROPERTY DETAILS */}
			<article className="property-details__section">
				<DetailSectionHeader icon="fa-trees" title="Property Details" />
				<div className="property-details__section-info d-flex align-items-start">
					<div className="col-6">
						<Building
							detailListStyle={detailListStyle}
							archStyle={archStyle}
							accessibilityFeatures={accessibilityFeatures}
							stories={stories}
							storiesTotal={storiesTotal}
							livingArea={livingArea}
							propertyType={propertyType}
							yearBuilt={yearBuilt}
							flooring={flooring}
							roof={roof}
							constructionMaterials={constructionMaterials}
						/>

						<LotInfo
							detailListStyle={detailListStyle}
							lotSizeArea={lotSizeArea}
							lotSizeAcres={lotSizeAcres}
							parcelNumber={parcelNumber}
						/>
					</div>

					<div className="col-6">
						<ExteriorFeatures
							detailListStyle={detailListStyle}
							exteriorFeatures={exteriorFeatures}
							fencing={fencing}
							poolPrivateYN={poolPrivateYN}
							poolFeatures={poolFeatures}
						/>

						<Parking
							detailListStyle={detailListStyle}
							parkingFeatures={parkingFeatures}
							garageYN={garageYN}
							attachedGarageYN={attachedGarageYN}
							carportYN={carportYN}
							carportSpaces={carportSpaces}
						/>

						<Ownership
							detailListStyle={detailListStyle}
							ownership={ownership}
							ownershipType={ownershipType}
						/>
					</div>
				</div>
			</article>

			{/* COMMUNITY DETAILS */}
			<article className="property-details__section">
				<DetailSectionHeader icon="fa-city" title="Community Details" />
				<div className="property-details__section-info d-flex align-items-start">
					<div className="col-6">
						<SchoolDistricts
							detailListStyle={detailListStyle}
							elementary={elementary}
							middle={middle}
							high={high}
						/>

						<SewerWater
							detailListStyle={detailListStyle}
							sewer={sewer}
							water={water}
						/>
					</div>
					<div className="col-6">
						<Neighborhood
							detailListStyle={detailListStyle}
							subdivisionName={subdivisionName}
							associationFee={associationFee}
							associationYN={associationYN}
							zoningDescription={zoningDescription}
							community={community}
						/>

						<AssessmentAndTaxes
							detailListStyle={detailListStyle}
							taxAssessedValue={taxAssessedValue}
							annualTax={annualTax}
							taxYear={taxYear}
						/>
					</div>
				</div>
			</article>

			<div className="w-100 cc-font-weight--bold cc-color--gray-500 mt-3 mb-4">Property details provided by {mapOriginatingSystemToSource[`${mlsCode}`]}.</div>
		</div>
	);
};

export default FullDetails;
